module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-chapter"
  }, [(!_vm.videos) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t("video.video.loading")) + "\n      "), _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.playUrl) ? _c('div', {
    staticClass: "player"
  }, [_c('h3', [_vm._v(_vm._s(_vm.playUrl.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.playUrl.description))]), _vm._v(" "), _c('VideoPlayer', {
    staticClass: "videoPlayer",
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.playUrl.url)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "done",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("video.video.finish")) + "\n      ")])], 1) : (_vm.videos) ? _c('div', {
    staticClass: "chapter-course"
  }, _vm._l((_vm.videos), function(section) {
    return _c('div', {
      staticClass: "collapsed",
      style: ({
        height: _vm.calculateHeight(section)
      })
    }, [_c('div', {
      staticClass: "lesson-type",
      on: {
        "click": function($event) {
          return _vm.pickType(section)
        }
      }
    }, [_c('div', [_c('div', [_c('h5', [_vm._v(_vm._s(section["title"]))])])]), _vm._v(" "), _c('div', {
      staticClass: "arrow-flex"
    }, [_c('div', {
      staticClass: "arrow"
    }, [_c('inline-svg', {
      class: _vm.pickedType == section ? 'upside-arrow' : 'down-arrow',
      attrs: {
        "src": require('../../assets/svg/arrow-down.svg').default
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "lessons-wrapper"
    }, _vm._l((section.lessons), function(videoa) {
      return _c('div', {
        key: videoa.id,
        staticClass: "step",
        class: {
          completed: _vm.userProgress.includes(videoa.id)
        },
        on: {
          "click": function($event) {
            return _vm.openLesson(videoa.id, videoa.permission)
          }
        }
      }, [_c('div', {
        staticClass: "v-stepper-course"
      }, [_c('div', {
        staticClass: "circle"
      }, [(_vm.userProgress.includes(videoa.id)) ? _c('inline-svg', {
        staticClass: "check-v-ex",
        attrs: {
          "src": require('../../assets/svg/GreenCheck.svg').default
        }
      }) : _vm._e(), _vm._v(" "), (
        videoa.permission !== 'unknown' &&
        videoa.permission !== _vm.permission &&
        _vm.permission !== 'paying' &&
        videoa.permission == 'paying'
      ) ? _c('inline-svg', {
        staticClass: "lockSign",
        attrs: {
          "width": "14px",
          "src": require('../../assets/svg/lock.svg').default
        },
        on: {
          "click": _vm.goPay
        }
      }) : _vm._e(), _vm._v(" "), (
        videoa.permission !== 'unknown' &&
        videoa.permission !== _vm.permission &&
        _vm.permission !== 'paying' &&
        videoa.permission == 'registered'
      ) ? _c('inline-svg', {
        staticClass: "lockSign",
        attrs: {
          "width": "14px",
          "src": require('../../assets/svg/googleicon.svg').default
        }
      }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
        staticClass: "gameText",
        class: {
          disbaled: videoa.permission !== 'unknown' &&
            videoa.permission !== _vm.permission &&
            _vm.permission !== 'paying'
        }
      }, [_vm._v("\n              " + _vm._s(videoa.name) + "\n            ")])])
    }), 0)])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57436520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Videos/Video.vue
// module id = 356
// module chunks = 0 11